import { Routes } from '@angular/router';
import { AddressComponent } from './orc-address/address.component';
import { FindMyAgentComponent } from './orc-find-my-agent/find-my-agent.component';
import { ResultsComponent } from './orc-results/results.component';
import { BedroomsComponent } from './ui-bedrooms/bedrooms.component';
import { BuyingComponent } from './ui-buying-step/buying.component';
import { ImportantComponent } from './ui-important/important.component';
import { PropertyTypeComponent } from './ui-property-type/property-type.component';
import { RentingComponent } from './ui-renting-step/renting.component';
import { WhenToSellComponent } from './ui-when-to-sell/when-to-sell.component';
import { WhyAreYouHereComponent } from './ui-why-are-you-here/why-are-you-here.component';

export const agentFinderRoutes: Routes = [
  {
    path: '',
    component: FindMyAgentComponent,
    data: {
      hideHeader: true,
      hideFooter: true,
    },
    children: [
      {
        path: '',
        redirectTo: 'whyareyouhere',
        pathMatch: 'full',
      },
      {
        path: 'whyareyouhere',
        component: WhyAreYouHereComponent,
        data: {
          initalStep: true,
        },
      },
      {
        path: 'propertytype',
        component: PropertyTypeComponent,
      },
      {
        path: 'bedrooms',
        component: BedroomsComponent,
      },
      {
        path: 'whentosell',
        component: WhenToSellComponent,
      },
      {
        path: 'address',
        component: AddressComponent,
      },
      {
        path: 'important',
        component: ImportantComponent,
      },
      {
        path: 'buying',
        component: BuyingComponent,
      },
      {
        path: 'renting',
        component: RentingComponent,
      },
      {
        path: 'results',
        component: ResultsComponent,
        data: {
          nonStep: true,
        },
      },
    ],
  },
  {
    path: '',
    loadChildren: () => import('@rma/generic/fallback-pages'),
  },
];
